import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=255fb5a0&scoped=true&"
import script from "./ChatWindow.vue?vue&type=script&lang=js&"
export * from "./ChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=255fb5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255fb5a0",
  null
  
)

export default component.exports